import { z } from "zod"

export const userUpdateProfileSchema = z.object({
  name: z.string().min(1).max(255),
})
export type userUpdateProfileValidationType = z.infer<
  typeof userUpdateProfileSchema
>

export const userUpdateSchema = z.object({
  id: z.uuid(),
  hasMutedReminders: z.boolean(),
})
export type userUpdateSchemaValidationType = z.infer<typeof userUpdateSchema>
